import React from 'react';
import { Menu } from '@uncinc/react-drupal-core';
import c from 'classnames';
import i18next from '../../../config/i18next';
import { CoreLink } from '../../../components';

const FooterSocialLinks = () => {
  return (
    <>
      <h4 className="FooterSocialMenu__title">{i18next.t('footer_social')}</h4>
      <Menu id="footer-social">

        {(items) => {
          return (
            <div className="FooterSocialMenu__items">
              {items.map((item, index) => {
                const attrs = item.getIn(['link', 'options', 'attributes'], new Map());
                const href = item.getIn(['link', 'url']);
                const title = item.getIn(['link', 'title'], 'Untitled');
                const className = c(attrs.getIn(['class']).join(' '));

                return (
                  <li key={`menu--footer-social--menu-item-${title}:${href}`}>
                    <CoreLink
                      className={className}
                      to={href}
                      target={attrs.get('target')}
                    >
                      {title}
                    </CoreLink>
                  </li>
                );

              })}
            </div>
          );
        }}
      </Menu>
    </>
  );
};

export default FooterSocialLinks;
